/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { nth } from 'lodash'
import { isMobile } from 'react-device-detect'
// icon
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
// css
import { TxtLimit } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { formatNumber } from '@utils/utils'
import { replaceOutcomeNameSpec } from 'game/util'
import useRootStore from '@store/useRootStore'
import { bettingHistoryStore, matchupStore } from '@store/index'
import { Schema$BettorBetRecord } from '@v2/protocol/my'
import { MoneyHistoryContentWrap } from '../index.style'
import dayjs from 'dayjs'
import { FROM_VIEW_TYPE } from '@v2/constants/common'
import PopupUtils from '@utils/popup-utils'

// icon
const Gmoney = (
  <GmoneyIco/>
)

interface MoneyHistoryListItemContentProps {
  contents: Schema$BettorBetRecord
}

const MoneyHistoryListItemContent: React.FC<MoneyHistoryListItemContentProps> = (
  props: MoneyHistoryListItemContentProps,
) => {
  const { routerStore, authStore, globalStore } = useRootStore()
  const { contents } = props
  const { bet, folds } = contents
  const { clubName, clubId, createdAt, foldCount, dividendRate, betMoney, dividend } = bet
  const { isSpecificClubMember, clubId: userClubId } = authStore.userInfo

  const makeDateElement = date => {
    const days = ['일', '월', '화', '수', '목', '금', '토']
    const dateAt = dayjs(date)
    const dateElem = (
      <span key={dateAt.valueOf()} className="date">
        {dateAt.format('MM/DD')}({nth(days, dateAt.day())})
        <span className="time">{dateAt.format('hh:mm:ss')}</span>
      </span>
    )
    return dateElem
  }

  const makeElement = () => {
    const elementList = []
    for (const fold of folds) {
      const foldKey = `MoneyHistoryListItemContent:Row:${fold.marketId}:${fold.matchId}:${fold.sportId}`
      const element = (
        <div key={`fold_${fold.matchId}_${foldKey}`} className="bet-list-wrap--match-wrap">

          <div className="bet-list-wrap--match-wrap--team-wrap">
            <span css={TxtLimit} className="bet-list-wrap--match-wrap--team-wrap--team-name">{fold.homeTeamName}</span>
            <span className="bet-list-wrap--match-wrap--team-wrap--vs">VS</span>
            <span css={TxtLimit} className="bet-list-wrap--match-wrap--team-wrap--team-name">{fold.awayTeamName}</span>
          </div>

          <span className="bet-list-wrap--match-wrap--team-wrap result">
            {replaceOutcomeNameSpec(fold.selectionName, fold.homeTeamName, fold.awayTeamName)}
          </span>
        </div>
      )
      elementList.push(element)
    }

    return elementList
  }

  const onClickJumpClubButton = () => {
    matchupStore.changeClubId(bet.clubId)
    if (!isMobile) {
      globalStore.resetGeneralPopupProperties()
    }
  }

  const onClickJumpBettingHistoryButton = () => {
    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.MONEY_HISTORY_LIST)
    bettingHistoryStore.setBettingHistoryInitProps({
      onlyMajorClub: false,
      fromViewType: FROM_VIEW_TYPE.MONEY_HISTORY_LIST,
    })
    if (isMobile) {
      routerStore.history.push('/betting-history')
    } else {
      PopupUtils.showBettingHistoryPopup()
    }
  }

  const isClubJumpAvailable = () => {
    if (isSpecificClubMember) {
      return clubId === userClubId
    }
    return !process.env.SPECIFIC_CLUB_IDS.includes(clubId)
  }

  return (
    <MoneyHistoryContentWrap>
      <div className="info-wrap">
        {makeDateElement(createdAt)}

        {isClubJumpAvailable() && (
          <Button TP onClick={onClickJumpClubButton} className="go-club-btn">
            {clubName}
            <span className="arrow-ico"/>
          </Button>
        )}
      </div>

      <span className="fold">
        폴드 {foldCount}
      </span>

      <div className="bet-list-wrap">
        {makeElement()}

        <div className="bet-list-wrap--money-wrap">
          <span className="bet-list-wrap--money-wrap--num">{Number(dividendRate).toFixed(2)}</span>
          <span className="bet-list-wrap--money-wrap--x">&times;</span>
          <span css={TxtLimit} className="bet-list-wrap--money-wrap--money">{formatNumber(betMoney)}</span>
          {Gmoney}
          <span className="bet-list-wrap--money-wrap--equal">=</span>
          <span className="bet-list-wrap--money-wrap--money" css={TxtLimit}>{formatNumber(dividend)}</span>
          {Gmoney}
        </div>
      </div>
      <Button navy onClick={onClickJumpBettingHistoryButton} className="go-betting-history-btn">
        베팅 내역 바로가기
      </Button>
    </MoneyHistoryContentWrap>
  )
}

export default MoneyHistoryListItemContent
